import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { EmptyState } from "@/components/bi/EmptyState";
import { Lock, Ban, Clock, KeyRound, Loader2 } from "lucide-react";

const Screen = ({ children }) => (
  <div className="min-h-screen flex items-center justify-center bi-canvas">{children}</div>
);

// Pre-dashboard gate screens for the public viewer. Returns an element or null.
export function viewerGateScreen({ error, gate, pw, setPw, pwError, pwSubmitting, submitPassword }) {
  if (error) return <Screen><EmptyState icon={Lock} title="Dashboard not available" description="This dashboard is private or the link is invalid." /></Screen>;
  if (gate && !gate.domain_ok) {
    return <Screen><EmptyState icon={Ban} title="Not allowed here" description={`This embed can only be viewed from allowed domains. This page (${window.location.hostname}) is not authorised.`} /></Screen>;
  }
  if (gate && gate.expired) {
    return <Screen><EmptyState icon={Clock} title={gate.archived ? "Dashboard archived" : "Link expired"} description={gate.archived ? "This dashboard has been archived by its owner and is no longer available." : "The share link for this dashboard has expired. Please ask the owner for a fresh link."} /></Screen>;
  }
  if (gate && gate.password_required && !gate.verified) {
    return (
      <Screen>
        <div data-testid="share-password-gate" className="rounded-2xl border border-[color:var(--glass-border)] bg-[color:var(--surface)] p-6 w-full max-w-sm shadow-xl">
          <div className="flex items-center gap-2 mb-2">
            <KeyRound className="w-5 h-5 text-[color:var(--brand-ocean)]" />
            <h2 className="font-display text-lg text-[color:var(--ink)]">Password required</h2>
          </div>
          <p className="text-sm text-[color:var(--ink-3)] mb-4">
            {gate.dashboard_name ? <><b>{gate.dashboard_name}</b> is </> : "This dashboard is "}
            protected. Enter the password to view.
          </p>
          <Label className="text-xs text-[color:var(--ink-3)]">Password</Label>
          <Input
            data-testid="share-password-input"
            type="password"
            autoFocus
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") submitPassword(); }}
            className="mt-1.5 bg-[color:var(--surface-2)]"
          />
          {pwError && <div className="text-[11px] text-[color:var(--danger)] mt-1">{pwError}</div>}
          <Button
            data-testid="share-password-submit"
            onClick={submitPassword}
            disabled={pwSubmitting || !pw}
            className="w-full mt-3 bg-[color:var(--brand-ocean)] text-white"
          >
            {pwSubmitting ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null}
            Unlock
          </Button>
        </div>
      </Screen>
    );
  }
  return null;
}
